import React from 'react';
import PropTypes from 'prop-types';

import {Box, Chip, Divider, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

import {translateOr} from '../format';

// Loom's client read already carries the caregiver's name, so this view loads no legacy profile and
// has no link to the legacy caregiver page.
const CaregiverView = (props) => {
  const [mouseOver, setMouseOver] = React.useState(false);

  const caregiver = props.caregiver;

  const {
    caregiverName,
    status = 'ACTIVE',
  } = caregiver;

  return (
    <Box>
      <Divider/>
      <Box
        onMouseOver={() => setMouseOver(true)}
        onMouseLeave={() => setMouseOver(false)}
        sx={{
          backgroundColor: mouseOver ? 'background.highlighted' : 'inherit',
          p: 2,
        }}
      >
        <Stack spacing={1}>
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            alignItems={{xs: 'flex-start', sm: 'center'}}
            justifyContent="space-between"
            spacing={1}
            sx={{
              pr: {xs: 0, sm: 5},
            }}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Chip
                label={translateOr(`loomLead.LoomLeadDetail.CaregiverConnections.Status.${status}`, status)}
                sx={{
                  backgroundColor: status === 'ACTIVE' ? '#FFE0CC' : '#FFD54F',
                  color: '#000',
                }}
              />
              <Stack>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  <Translate expression='loomLead.LoomLeadDetail.CaregiverConnections.Caregiver.CaregiverName'/>
                </Typography>
                <Typography
                  sx={{
                    fontSize: '14px',
                  }}
                >
                  {caregiverName || '-'}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

CaregiverView.propTypes = {
  caregiver: PropTypes.shape({
    caregiverRn: PropTypes.string,
    caregiverName: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
};

export default React.memo(CaregiverView);
